/* =================================================================
   br-footer — column-head state bookkeeping.

   The mobile link-column accordion was removed on 2026-08-07: every
   column renders expanded at every width, and the column head is
   inert text. This script's only remaining job is to keep the DOM
   honest about that: the heads are <button>s in the markup, so with
   JS they are disabled (out of the tab order) and report
   aria-expanded="true" — matching the always-visible columns.

   Without JS the markup's own aria-expanded="true" already matches
   the rendered state, so the footer degrades to a plain stacked list
   either way.
   ================================================================= */
(function () {
  function setup(footer) {
    var cols = footer.querySelectorAll('.br-footer__col');
    if (!cols.length) return;

    footer.classList.add('br-footer--js');

    cols.forEach(function (col) {
      var toggle = col.querySelector('.br-footer__col-toggle');
      col.classList.add('is-open');
      toggle.disabled = true; // inert at every width — out of tab order
      toggle.setAttribute('aria-expanded', 'true');
    });
  }

  document.querySelectorAll('.br-footer').forEach(setup);
})();
